export const MALE = 'MALE';
export const FEMALE = 'FEMALE';
export const MALE_TITLES = [{ code: 'Mr', description: 'Mr', displayOrder: 1 }];
export const FEMALE_TITLES = [
    { code: 'Mrs', description: 'Mrs', displayOrder: 2 },
    { code: 'Miss', description: 'Miss', displayOrder: 3 },
];
export const ALL_TITLES = [...MALE_TITLES, ...FEMALE_TITLES];

export const PRODUCT_DETAIL_URL = '/personal/gi-claims/';
export const AMC_URL_PREFIX = '/personal/claims/allsure-motor-claim';
export const APP_NOT_INITIATED = 'APP_NOT_INITIATED';
export const CATEGORY = {
    GLASS_WINDSCREEN: 'Glass/Windscreen claim',
    ACCIDENTAL_OWN_DAMAGE: 'Accidental/ Own damage claim',
    THEFT_HIJACK: 'Theft/Hijack Claim',
    THIRD_PARTY: 'Third party claim',
};
export const PAGES = [
    {
        URL: `${AMC_URL_PREFIX}/category/`,
        URL_PART: 'category',
        TITLE: 'Category Type',
    },
    {
        URL: `${AMC_URL_PREFIX}/basic-details/`,
        URL_PART: 'basic-details',
        TITLE: 'Basic Details',
    },
    {
        URL: `${AMC_URL_PREFIX}/incident-details/`,
        URL_PART: 'incident-details',
        TITLE: 'Incident Details',
    },
    {
        URL: `${AMC_URL_PREFIX}/other-details/`,
        URL_PART: 'other-details',
        TITLE: 'Other Details',
    },
    {
        URL: `${AMC_URL_PREFIX}/upload-documents/`,
        URL_PART: 'upload-documents',
        TITLE: 'Upload Documents',
    },
    {
        URL: `${AMC_URL_PREFIX}/confirmation/`,
        URL_PART: 'confirmation',
        TITLE: 'Confirmation Page',
    },
    {
        URL: `${AMC_URL_PREFIX}/successful/`,
        URL_PART: 'successful',
        TITLE: 'Success Page',
    },
];

export const PAGE_URLS = {
    QUOTE: PRODUCT_DETAIL_URL,
    CATEGORY: `${AMC_URL_PREFIX}/${PAGES[0].URL_PART}`,
    BASIC_DETAILS: `${AMC_URL_PREFIX}/${PAGES[1].URL_PART}`,
    INCIDENT_DETAILS: `${AMC_URL_PREFIX}/${PAGES[2].URL_PART}`,
    OTHER_DETAILS: `${AMC_URL_PREFIX}/${PAGES[3].URL_PART}`,
    UPLOAD_DOCUMENTS: `${AMC_URL_PREFIX}/${PAGES[4].URL_PART}`,
    CONFIRMATION: `${AMC_URL_PREFIX}/${PAGES[5].URL_PART}`,
    SUCCESS: `${AMC_URL_PREFIX}/${PAGES[6].URL_PART}`,
};

export const PAGE_INDICES = {
    CATEGORY: 0,
    BASIC_DETAILS: 1,
    INCIDENT_DETAILS: 2,
    OTHER_DETAILS: 3,
    UPLOAD_DOCUMENTS: 4,
    CONFIRMATION: 5,
    SUCCESS: 6,
};

const SIZE_2_MB = 2097152;
const SIZE_1_kb = 1024;

export const UPLOAD_PAGE_CONFIG = {
    MIN_INPUT_SIZE: SIZE_1_kb,
    MIN_INPUT_SIZE_NAME: '1 kb',
    MAX_INPUT_SIZE: SIZE_2_MB,
    MAX_INPUT_SIZE_NAME: '2 mb',
    VALID_UPLOAD_TYPES: [
        { FORMAT: 'image/jpeg', FORMAT_NAME: 'JPG' },
        { FORMAT: 'image/png', FORMAT_NAME: 'PNG' },
        { FORMAT: 'application/pdf', FORMAT_NAME: 'PDF' },
    ],
};

export const RADIO_OPTION = {
    YES: 'Yes',
    NO: 'No',
    NA: 'Not Applicable',
};
export const AMC_MANDATORY_DOCUMENTS = {
    WINDSCREEN: ['repairQuotes'],
    THEFT: [
        'certifiedCopyOfId',
        'driverLicense',
        'vehicleRegistration',
        // 'stolenAcceessoryInvoice',
        'vehicleRecoveryProof',
        'policeReport',
    ],
    ACCIDENTAL: [
        'certifiedCopyOfId',
        'policeReport',
        'policeStatement',
        'policeSketchPlan',
        'driverLicense',
        'vehicleRegistration',
        'repairQuotes',
    ],
    THIRDPARTY: [
        'certifiedCopyOfId',
        'driverLicense',
        'vehicleRegistration',
        'vehicleRecoveryProof',
        'stolenAcceessoryInvoice',
    ],
};

export const PROGRESS_BAR_STEPS = [
    {
        title: 'Basic Details',
        key: 'BASIC_DETAILS',
        isActive: false,
        isCompleted: false,
    },
    {
        title: 'Incident Details',
        key: 'INCIDENT_DETAILS',
        isActive: false,
        isCompleted: false,
    },
    {
        title: 'Other Details',
        key: 'OTHER_DETAILS',
        isActive: false,
        isCompleted: false,
    },
    {
        title: 'Upload Documents',
        key: 'UPLOAD_DOCUMENTS',
        isActive: false,
        isCompleted: false,
    },
    {
        title: 'Confirmation',
        key: 'CONFIRMATION',
        isActive: false,
        isCompleted: false,
    },
];

export const AMC_REQUIRED_DOCUMENTS = {
    certifiedCopyOfId: {
        key: 'certifiedCopyOfId',
        title: 'Certified copy of Omang/ID card or passport',
        caption: 'Not more than 5 years old',
    },
    driverLicense: {
        key: 'driverLicense',
        title: 'Copy of driver’s licence',
        caption: 'Proof of the driver’s identity and authorization',
    },
    vehicleRegistration: {
        key: 'vehicleRegistration',
        title: 'Copy of vehicle registration book',
        caption: 'Verification of vehicle ownership',
    },
    vehicleRecoveryProof: {
        key: 'vehicleRecoveryProof',
        title: 'Anti-theft/vehicle recovery proof of device (Optional)',
        caption: 'Anti-theft/vehicle recovery proof of device',
    },
    stolenAcceessoryInvoice: {
        key: 'stolenAcceessoryInvoice',
        title: 'Stolen Accessories Invoices',
        caption: 'Stolen accessories invoices',
    },
    repairQuotes: {
        key: 'repairQuotes',
        title: 'Two repair or replacement quotes',
        caption: 'For the damaged property, including itemized costs',
    },
    policeStatement: {
        key: 'policeStatement',
        title: 'Police statement',
        caption: 'Official report detailing the incident',
    },
    policeSketchPlan: {
        key: 'policeSketchPlan',
        title: 'Police sketch plan',
        caption: 'Diagram illustrating the accident scene',
    },
    policeReport: {
        key: 'policeReport',
        title: 'Police report',
        caption: 'Police report detailing the incident',
    },
    additionalDocument: {
        key: 'additionalDocument',
        title: 'Additional document',
        caption: 'Additional document',
    },
};
export const FILE_ICONS = {
    jpg: 'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt56d6e81d602c99de/6797a371b19afb369b7afda0/File_Icon_JPG.svg',
    jpeg: 'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blteca5e7feca91f3e6/6797a373b649e6acfd7702ab/File_Icon_JPEG.svg',
    pdf: 'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt28588d3724fd5c5f/6797a373786c5a20389b1511/File_Icon_PDF.svg',
    tif: 'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt3b6c0bce2454acfa/6797a3746c6824e35038a066/File_Icon_TIF.svg',
    tiff: 'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt4e38e3635afb2e77/6797a372274f954ab2ce7426/File_Icon_TIFF.svg',
    png: 'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt8595e906f89120f7/6797a372274f95371fce7428/File_Icon_PNG.svg',
};

export const BASIC_DETAILS_LABELS = {
    policyNumber: 'Policy number *',
    fullName: 'Full name *',
    mobileNumber: 'Cellphone number *',
    email: 'Email address *',
};
export const INCIDENT_DETAIL_LABELS = {
    vehicleMake: 'Vehicle make *',
    mentionedVehicleMake: 'Vehicle make *',
    vehicleModel: 'Vehicle model *',
    mentionedVehicleModel: 'Vehicle model *',
    registrationNumber: 'Registration number *',
    vehicleYear: 'Vehicle year *',
    creditAgreement: 'Is the vehicle subject to credit or similar agreement? *',
    nameOfFinance: 'Name of finance company *',
    addressOfFinance: 'Physical address of finance company *',
    nameOfVehicleRegistration: 'In whose name is the vehicle registered? *',
    dateOfIncident: 'Date of incident *',
    reasonForDelay: 'Reason for late notification *',
    timeOfIncident: 'Time of incident *',
    addressOrLocation: 'Address or location of the incident *',
    windScreenType: 'Windscreen type *',
    causeOfBreakage: 'Cause of breakage *',
    personResponsible: 'Person responsible for breakage (Optional)',
    witness: 'Select number of witnesses (Optional)',
    driverName: 'Driver’s name *',
    driverLicense: 'Driver’s licence *',
    driverLicenseNumber: 'Driver’s licence number *',
    driverLicenseCode: 'Driver’s licence code *',
    thirdParty: 'Is a third party responsible for the loss or damage? *',
    thirdPartyName: 'Full name of third party (Optional)',
    thirdPartyNumber: 'Third party cellphone number (Optional)',
    thirdPartyAddress: 'Third party address (Optional)',
    thirdPartyEmail: 'Third party email address (Optional)',
    personToBeKeptInformed: 'Alternate person to be kept informed of the claim process (Optional)',
    personsFullName: 'Contact person’s full name *',
    personsContact: 'Contact person’s cellphone number *',
    personsEmail: 'Contact person’s email address (Optional)',
    mileage: 'Mileage (In km)*',
    vehicleIdNumber: 'Vehicle identification number (Optional)',
    chassisNumber: 'Chassis number *',
    engineNumber: 'Engine number *',
    exteriorColor: 'Exterior colour *',
    interiorColor: 'Interior colour *',
    grossVehicleMass: 'Gross vehicle mass (In kg)*',
    tare: 'Tare/Unladen weight (In kg) *',
    vehicleValue: 'Vehicle value (In P) *',
    dateOfPurchase: 'Date of purchase *',
    kiloMeterCompleted: 'Kilometers completed/mileage *',
};
export const ACCIDENT_LABELS = {
    dateOfAccident: 'Date of incident *',
    reasonForDelayAccident: 'Reason for late notification *',
    timeOfIncidentAccident: 'Time of incident *',
    addressOrLocationAccident: 'Address or location of the incident *',
    speedBeforeImpact: 'Speed before impact (In km/h) *',
    speedAfterImpact: 'Speed at moment of impact (In km/h) *',
    weatherCondition: 'Weather condition at the time of incident * ',
    // otherWeatherCondition: 'Please enter which other Weather condition at the time of incident *',
    visibilityAtTheTimeOfIncident: 'Visibility at the time of incident *',
    otherVisibility: 'Please enter which other visibility conditions were present at the time of the incident. *',
    roadSurfaceType: 'Road surface type *',
    // otherRoadSurfaceType: 'Please enter which other road surface type *',
    widthOfRoad: 'Width of road *',
    // otherWidthOfRoad: 'Please enter which other width of road *',
    vehicleLightIncident: 'Vehicle lights in use at the time of incident *',
    // otherVehicleLightIncident:'Please enter which other vehicle lights in use at the time of incident *',
    streetLight: 'Was the streetlight on at the time of the accident? *',
    warning: 'Was any warning given to you? *',
};
export const DETAILS_OF_PASSENGER = {
    anyPassenger: 'Were there any passengers in the car besides the driver? ',
    passenger: 'Select number of passengers that were in the vehicle at the time of accident',
    passengerName: 'Name of passenger',
    passengerAddress: 'Address of passenger',
    passengerInjury: 'Injury of passenger',
    purpose: 'For what purpose were they carried?',
    employee: 'Are they employees?',
};
export const WITNESS_DETAILS = {
    witness: 'Select number of witnesses',
    witnessName: 'Name of witness',
    witnessAddress: 'Address of witness',
    witnessPhone: 'Telephone number of witness',
    // witnessEmail: 'Email',
};
export const OTHER_DETAIL_LABELS = {
    description: 'Full description of broken glass *',
    windScreenSize: 'Windscreen size in millimeters *',
    brokenGlass: 'Any sign writing on broken glass? *',
    crackOrShattered: 'Is the windscreen cracked or completely shattered? *',
    dateOfIncident: 'Date of theft *',
    reasonForDelay: 'Reason for late notification *',
    timeOfIncident: 'Time of theft *',
    placeWhereTheftOccurred: 'Place where theft occurred *',
    policeStationReportedTo: 'Police station reported to *',
    sapsCaseNumber: 'Police case number *',
    dateReported: 'Date reported *',
    reportedBy: 'Reported by *',
    circumstancesOfTheft: 'Describe how the theft occurred? *',
    vehicleLocked: 'Was the vehicle locked? *',
    reasonOfLock: 'If not, give reasons *',
    detailsStolenAccessories: 'Details of stolen accessories (Optional)',
    associateSecured: 'Are these accessories separately insured? (Optional)',
    antiTheft: 'Do you have an anti-theft or vehicle recovery device in your car? *',
    make: 'Make  (Optional)',
    fittedBy: 'Fitted by  (Optional)',
    dateFitted: 'Date fitted  (Optional)',
    windowNumber: 'Number  (Optional)',
    appliedByWhom: 'Applied by whom  (Optional)',
    detailsOfDents: 'Did the vehicle have any existing scratches, dents, and defects that can be used to identify the vehicle? *',
    detailsOfOtherFeatures: 'Details of other features which would assist identification *',
};

export const POLICE_DETAILS_LABELS = {
    nameOfPoliceOfficer: 'Full name of police officer *',
    stationName: 'Station name *',
    referenceNumber: 'Reference number *',
    dateOfReported: 'Date reported *',
    testedAlcohol: 'Was the driver tested for alcohol and drugs? *',
    descriptionOfAccident: 'Description of accident  *',
};
export const DRIVER_DETAILS = {
    parked: 'Was the vehicle parked or driven at the time of incident? *',
    driverLicense: 'Driver’s licence *',
    driverName: 'Driver’s name *',
    driverIdNumber: 'Driver’s ID number *',
    driverAge: 'Driver’s age *',
    driverLicenseNumber: 'Driver’s licence number *',
    driverLicenseCode: 'Driver’s licence code *',
    vehicleUse: 'State fully the purpose for which the vehicle was being used. *',
    driverOwner: 'Was the driver the owner of the vehicle? *',
    drivingPermission: 'Was he/she driving with your permission? *',
    employee: 'Was he/she your employee? *',
    ownerOfOtherVehicle: 'Is he/she the owner of another vehicle? (Optional)',
    nameOfInsurer: 'Name of insurer *',
    policyNumber: 'Policy number  *',
    convictionsDetails: 'Details of any convictions for motoring offences. *',
    licenseEndorse: 'Has the licence ever been endorsed? *',
    physicalDefects: 'Does he/she have any physical conditions or impairments? *',
    previousAccidentDetails: 'Details of previous accidents. *',
};
export const OTHER_DETAILS_ACCIDENTAL = {};
export const OTHER_THIRD_PARTY = {
    thirdParty: 'Do you have details of the third party? *',
    thirdPartyMake: 'Vehicle make (Optional)',
    thirdPartyRegistrationNumber: 'Registration number  (Optional)',
    thirdPartyNameOfOwner: 'Full name of owner (Optional)',
    thirdPartyAddressOfOwner: 'Address of owner  (Optional)',
    thirdPartyDriverName: 'Full name of driver (Optional)',
    thirdPartyAddressOfDriver: 'Address of driver  (Optional)',
    thirdPartyEmailDriver: 'Email, telephone/cellphone number (Optional)',
    thirdPartyInsuranceCompanyName: 'Insurance company name (Optional)',
    thirdPartyPolicyNumber: 'Policy number  (Optional)',
};
export const DAMAGE_PROPERTY = {
    anyOtherProperty: 'Was any property damaged other than the vehicle? *',
    detailOfDamageProperty: 'Do you have details of the property damaged other than the vehicle? *',
    nameOfOwner: 'Name of owner (Optional)',
    addressOfOwner: 'Address of owner (Optional)',
    detailsDamage: 'Details of damage (Optional)',
};

export const PERSONAL_INJURIES = {
    outSidePersonalInjuries: 'Were there any personal injuries outside the insured’s vehicle? *',
    detailsOfInjuries: 'Do you have details of the injuries and the injured person? (Optional)',
    nameOfInjured: 'Name of injured (Optional)',
    nameOfHospital: 'Name of hospital (Optional)',
    detailsOfInjury: 'Details of injury (Optional)',
    relationShipToAccident: 'Relationship to accident (Optional)',
};

export const COMMON_FIELDS_INCIDENT = [
    'vehicleMake',
    'mentionedVehicleMake',
    'vehicleModel',
    'mentionedVehicleModel',
    'registrationNumber',
    'vehicleYear',
    'creditAgreement',
    'nameOfFinance',
    'addressOfFinance',
    'nameOfVehicleRegistration',
    'personToBeKeptInformed',
    'personsFullName',
    'personsContact',
    'personsEmail',
];
const CLAIM_TYPE_WINDSCREEN_INCIDENT_FIELDS = [
    'dateOfIncident',
    'reasonForDelay',
    'timeOfIncident',
    'addressOrLocation',
    'windScreenType',
    'causeOfBreakage',
    'personResponsible',
    'driverName',
    'driverLicense',
    'driverLicenseNumber',
    'driverLicenseCode',
    'thirdParty',
    'thirdPartyName',
    'thirdPartyNumber',
    'thirdPartyAddress',
    'thirdPartyEmail',
    // 'witness',
];
const CLAIM_TYPE_THEFT_INCIDENT_FIELDS = [
    'mileage',
    'chassisNumber',
    'engineNumber',
    'exteriorColor',
    'interiorColor',
    'driverName',
    'driverLicense',
    'driverLicenseNumber',
    'driverLicenseCode',
    'vehicleIdNumber',
    // 'witness',
];
const CLAIM_TYPE_ACCIDENT_INCIDENT_FIELDS = [
    'grossVehicleMass',
    'tare',
    'vehicleValue',
    'dateOfPurchase',
    'kiloMeterCompleted',
    'dateOfAccident',
    'reasonForDelayAccident',
    'timeOfIncidentAccident',
    'addressOrLocationAccident',
    'speedBeforeImpact',
    'speedAfterImpact',
    'weatherCondition',
    'visibilityAtTheTimeOfIncident',
    'otherVisibility',
    'roadSurfaceType',
    'widthOfRoad',
    'vehicleLightIncident',
    'streetLight',
    'warning',
    'thirdParty',
    'thirdPartyName',
    'thirdPartyNumber',
    'thirdPartyAddress',
    'thirdPartyEmail',
    'anyPassenger',
    'employee',
    'purpose',
    // 'passenger',
];

export const incidentFieldsForClaimType = {
    WINDSCREEN: [...COMMON_FIELDS_INCIDENT, ...CLAIM_TYPE_WINDSCREEN_INCIDENT_FIELDS],
    THEFT: [...COMMON_FIELDS_INCIDENT, ...CLAIM_TYPE_THEFT_INCIDENT_FIELDS],
    ACCIDENTAL: [...COMMON_FIELDS_INCIDENT, ...CLAIM_TYPE_ACCIDENT_INCIDENT_FIELDS],
    THIRDPARTY: [...COMMON_FIELDS_INCIDENT, ...CLAIM_TYPE_ACCIDENT_INCIDENT_FIELDS],
    DEFAULT: [],
};

const CLAIM_TYPE_WINDSCREEN_OTHER_FIELDS = ['description', 'windScreenSize', 'brokenGlass', 'crackOrShattered'];
const CLAIM_TYPE_THEFT_OTHER_FIELDS = [
    'dateOfIncident',
    'reasonForDelay',
    'timeOfIncident',
    'placeWhereTheftOccurred',
    'policeStationReportedTo',
    'sapsCaseNumber',
    'dateReported',
    'reportedBy',
    'circumstancesOfTheft',
    'vehicleLocked',
    'reasonOfLock',
    'detailsStolenAccessories',
    'associateSecured',
    'antiTheft',
    'make',
    'fittedBy',
    'dateFitted',
    'windowNumber',
    'appliedByWhom',
    'detailsOfDents',
    'detailsOfOtherFeatures',
];
const CLAIM_TYPE_ACCIDENT_OTHER_FIELDS = [
    'nameOfPoliceOfficer',
    'stationName',
    'referenceNumber',
    'dateOfReported',
    'testedAlcohol',
    'descriptionOfAccident',
    'parked',
    'driverName',
    'driverIdNumber',
    'driverAge',
    'driverLicense',
    'driverLicenseNumber',
    'driverLicenseCode',
    'vehicleUse',
    'driverOwner',
    'drivingPermission',
    'employee',
    'ownerOfOtherVehicle',
    'nameOfInsurer',
    'policyNumber',
    'convictionsDetails',
    'licenseEndorse',
    'physicalDefects',
    'previousAccidentDetails',
    'thirdParty',
    'thirdPartyMake',
    'thirdPartyRegistrationNumber',
    'thirdPartyNameOfOwner',
    'thirdPartyAddressOfOwner',
    'thirdPartyDriverName',
    'thirdPartyAddressOfDriver',
    'thirdPartyEmailDriver',
    'thirdPartyInsuranceCompanyName',
    'thirdPartyPolicyNumber',
    'anyOtherProperty',
    'detailOfDamageProperty',
    'nameOfOwner',
    'addressOfOwner',
    'detailsDamage',
    'outSidePersonalInjuries',
    'detailsOfInjuries',
    'nameOfInjured',
    'nameOfHospital',
    'detailsOfInjury',
    'relationShipToAccident',
    // 'witness'
];

export const otherFieldsForClaimType = {
    WINDSCREEN: CLAIM_TYPE_WINDSCREEN_OTHER_FIELDS,
    THEFT: CLAIM_TYPE_THEFT_OTHER_FIELDS,
    ACCIDENTAL: CLAIM_TYPE_ACCIDENT_OTHER_FIELDS,
    THIRDPARTY: CLAIM_TYPE_ACCIDENT_OTHER_FIELDS,
    DEFAULT: [],
};
